import { configureStore } from '@reduxjs/toolkit';
import { panelReducer } from '@origo/origo-components';
import { mapSlice } from '@origo/map-context';
import { authCombinedReducer } from '@origo/auth';

const store = configureStore({
    reducer: {
        panel: panelReducer,
        map: mapSlice.reducer,
        auth: authCombinedReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
